import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import ServiceItem from './components/ServiceItem/ServiceItem';

const ServiceList = () => {
	const { t } = useTranslation();

	return (
		<Fragment>
			<ServiceItem title={t('servicesSection.services.webDevelopment.title')} icon="display" animationDelay={200}>
				<div dangerouslySetInnerHTML={{ __html: t('servicesSection.services.webDevelopment.description') }} />
			</ServiceItem>
			<ServiceItem
				title={t('servicesSection.services.mobileDevelopment.title')}
				icon="mobile-screen-button"
				animationDelay={400}
			>
				<div dangerouslySetInnerHTML={{ __html: t('servicesSection.services.mobileDevelopment.description') }} />
			</ServiceItem>
			<ServiceItem title={t('servicesSection.services.consulting.title')} icon="file-code" animationDelay={200}>
				<div dangerouslySetInnerHTML={{ __html: t('servicesSection.services.consulting.description') }} />
			</ServiceItem>
			<ServiceItem title={t('servicesSection.services.agileConsulting.title')} icon="chart-simple" animationDelay={400}>
				<div dangerouslySetInnerHTML={{ __html: t('servicesSection.services.agileConsulting.description') }} />
			</ServiceItem>
		</Fragment>
	);
};

export default ServiceList;
